export const NF_STATUS = {
  DOWNLOADED: 'True',
  DENIED: 'False',
};

export const NF_STATUS_TRANSCRIPT = {
  [NF_STATUS.DOWNLOADED]: 'Baixada',
  [NF_STATUS.DENIED]: 'Recusada',
  [NF_STATUS.PARTIAL]: 'Baixa Parcial',
};

export const DELIVERY_STATUS_ENUM = {
  REFUSED: 0,
  PARTIAL: 1,
  TOTAL: 2,
};

export const DELIVERY_STATUS_ENUM_TRANSKEY = {
  [DELIVERY_STATUS_ENUM.REFUSED]: 'Entrega recusada',
  [DELIVERY_STATUS_ENUM.PARTIAL]: 'Entrega parcial',
  [DELIVERY_STATUS_ENUM.TOTAL]: 'Entrega total',
};
